/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceStatusDataSchema = z.object({
	invoiceId: z.string(),
	status: z.string(),
	amountDue: z.number(),
	amountPaid: z.number(),
	total: z.number(),
	currency: z.string(),
	dueDate: z.iso.datetime().nullable(),
	hostedInvoiceUrl: z.string().nullable(),
	canLaunchCampaign: z.boolean(),
	isOverdue: z.boolean(),
	credited: z.boolean(),
})

export type InvoiceStatusDataSchema = z.infer<typeof invoiceStatusDataSchema>
